<template>
  <div class="d-flex" id="wrapper">
    <Sidebar :toggler.sync="isToggled" />

    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <section id="description">
        <div class="row">
          <div class="col-md-8">
            <div class="card custom-card">
              <div class="candidate d-none d-sm-block" style="border-radius: 8px 8px 0 0">
                <div class="d-flex align-items-center">
                  <Avatar :photo="selectedAvatar" @new="getAvatar" />
                  <span v-if="!isInGlobalEditMode" class="candidate-name">
                    <b>{{ getEmployerById.name }}</b>
                    <span v-if="tab === 0" class="candidate-edit mt-n1 ml-3">
                      <router-link to v-show="!isInGlobalEditMode">
                        <svgHelper
                          @click.native="changeGlobalEditMode()"
                          class="candidate-edit-icon"
                          name="edit"
                        ></svgHelper>
                      </router-link>
                    </span>
                  </span>

                  <span v-else class="candidate-name flex-grow-1 mr-2 my-auto">
                    <input
                      type="text"
                      class="form-control"
                      id="employer_name"
                      v-model="selectedName"
                    />
                  </span>
                  <div v-if="!isInGlobalEditMode" class="single-job-controls d-flex ml-auto">
                    <!--   <select
                      class="form-control select-style pr-4"
                      @change="onChangeEmployerStatus"
                      v-model="selectedEmployerStatus"
                    >
                      <option
                        v-for="option in employerStatusOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select> -->
                    <button
                      type="button"
                      class="btn btn-success add-employer-btn text-nowrap"
                      @click="showModal = true"
                    >
                      Add Employer
                      <portal to="add-employer-modal">
                        <CustomMainModal @close="onCloseAddEmployerModal" v-show="showModal">
                          <template v-slot:header>
                            <h5>Add Employer</h5>
                          </template>
                          <AddEmployerBtnModal v-if="showModal" />
                        </CustomMainModal>
                      </portal>
                    </button>
                  </div>

                  <div v-else class="form-buttons text-right ml-auto">
                    <button @click="updateEmployer" class="btn btn-primary ml-auto">Save</button>
                    <button @click="onCancelUpdateForm" class="btn btn-danger ml-2">Cancel</button>
                    <br />
                    <i
                      style="cursor: pointer; font-size: 21px"
                      data-toggle="modal"
                      href="#deleteEmployerModal"
                      class="fas fa-trash-alt mt-2"
                    ></i>
                  </div>
                </div>
              </div>

              <nav class="job-controls-tabs">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    @click="tab = 0"
                    class="nav-item nav-link active"
                    id="nav-primary-tab"
                    data-toggle="tab"
                    href="#nav-primary"
                    role="tab"
                    aria-controls="nav-primary"
                    aria-selected="true"
                    ><i class="far fa-credit-card d-block d-sm-none"></i> DETAILS</a
                  >
                  <a
                    v-if="getAccType === 'admin'"
                    @click="tab = 1"
                    class="nav-item nav-link d-none d-sm-block"
                    id="nav-templates-tab"
                    data-toggle="tab"
                    href="#nav-templates"
                    role="tab"
                    aria-controls="nav-templates"
                    aria-selected="false"
                    >TEMPLATES</a
                  >
                  <a
                    @click="
                      tab = 1;
                      setAgreementOnLoad();
                    "
                    class="nav-item nav-link d-none d-sm-block"
                    id="nav-agreements-tab"
                    data-toggle="tab"
                    href="#nav-agreements"
                    role="tab"
                    aria-controls="nav-agreements"
                    aria-selected="false"
                    >Agreements</a
                  >
                  <a
                    @click="tab = 2"
                    class="nav-item nav-link"
                    id="nav-comments-tab"
                    data-toggle="tab"
                    href="#nav-comments"
                    role="tab"
                    aria-controls="nav-comments"
                    aria-selected="false"
                    ><i class="fas fa-comments d-block d-sm-none"></i> COMMENTS
                    <span
                      v-show="getEmployerComments.length ? true : false"
                      class="badge badge-light"
                      >{{ getEmployerComments.length }}</span
                    ></a
                  >

                  <a
                    @click="tab = 3"
                    class="nav-item nav-link mobile-only"
                    id="nav-jobs-tab"
                    data-toggle="tab"
                    href="#nav-jobs"
                    role="tab"
                    aria-controls="nav-jobs"
                    aria-selected="false"
                    ><i class="fas fa-calendar-check d-block d-sm-none"></i> Jobs</a
                  >
                  <a
                    @click="tab = 4"
                    class="nav-item nav-link mobile-only"
                    id="nav-activity-tab"
                    data-toggle="tab"
                    href="#nav-activity"
                    role="tab"
                    aria-controls="nav-activity"
                    aria-selected="false"
                    ><i class="fas fa-chart-bar d-block d-sm-none"></i> activities</a
                  >
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="nav-primary"
                  role="tabpanel"
                  aria-labelledby="nav-primary-tab"
                >
                  <form @submit.prevent="updateEmployer" ref="globalUpdateForm">
                    <!-- Editable info global -->
                    <div class="candidate d-block d-sm-none" style="border-radius: 8px 8px 0 0">
                      <figure class="employer-picture d-flex align-items-center">
                        <img
                          class="rounded-circle mr-3"
                          src="https://media-exp1.licdn.com/dms/image/C560BAQF_1BqcCYk5iw/company-logo_200_200/0?e=2159024400&v=beta&t=VIwymtUGPLl3EApxziNxNiYNmAJHRYrTq28-lPwErsM"
                          alt="avatar"
                        />
                        <!-- <div v-if="!isInGlobalEditMode" class="candidate-name d-none d-sm-block">
                          <b>{{ getEmployerById.name }}</b>
                          <span class="candidate-edit mt-n1 ml-3">
                            <router-link to v-show="!isInGlobalEditMode">
                              <svgHelper
                                @click.native="changeGlobalEditMode"
                                class="candidate-edit-icon"
                                name="edit"
                              />
                            </router-link>
                          </span>
                        </div>

                        <div v-else class="candidate-name my-auto">
                          <input
                            type="text"
                            class="form-control"
                            id="employer_name"
                            v-model="selectedFirstName"
                          />
                        </div> -->
                        <div class="single-job-controls ml-auto d-none d-sm-block">
                          <button
                            type="button"
                            class="btn btn-success add-job-btn"
                            style="white-space: nowrap; position: relative; top: 5px; right: 0"
                          >
                            <i class="fas fa-plus-circle mr-2"></i>Add Employer
                          </button>
                        </div>
                      </figure>
                    </div>

                    <ul class="list-group list-group-flush employer-details">
                      <div class="row">
                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.orgoFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.orgo = true"
                            @mouseleave="editFields.orgo = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Registration number</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.orgo" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="orgo"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ getEmployerById.registration_number }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Registration number</b>
                            </span>

                            <input
                              id="orgo-number"
                              v-model="selectedOrgo"
                              type="text"
                              class="form-control mr-1"
                            />
                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>
                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.orgoFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.vatFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.vat = true"
                            @mouseleave="editFields.vat = false"
                            class="d-flex"
                          >
                            <span>
                              <b>EU VAT number</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.vat" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="vat"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ getEmployerById.eu_vat_number }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>EU VAT number</b>
                            </span>

                            <input
                              id="vat"
                              v-model="selectedVat"
                              type="text"
                              class="form-control mr-1"
                            />
                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>
                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.vatFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.firstNameFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.firstName = true"
                            @mouseleave="editFields.firstName = false"
                            class="d-flex"
                          >
                            <span>
                              <b>First name</b>
                            </span>
                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.firstName" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="first-name"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ getEmployerById.first_name }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>First name</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="first_name"
                              placeholder="First Name"
                              v-model="selectedFirstName"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              style="margin-right: 12px"
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.firstNameFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6 d-none d-sm-block">
                          <div
                            v-if="!editIconState.streetAddressFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.streetAddress = true"
                            @mouseleave="editFields.streetAddress = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Street address</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.streetAddress" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="street-address"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>

                              {{ getEmployerById.address.address }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Street address</b>
                            </span>

                            <input
                              type="text"
                              class="form-control"
                              id="street-address"
                              placeholder="Address"
                              v-model="selectedAddress"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.streetAddressFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.lastNameFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.lastName = true"
                            @mouseleave="editFields.lastName = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Last name</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.lastName" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="last-name"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ getEmployerById.last_name }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Last name</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="last_name"
                              placeholder="First Name"
                              v-model="selectedLastName"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              style="margin-right: 12px"
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.lastNameFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.postalCodeFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.postalCode = true"
                            @mouseleave="editFields.postalCode = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Postal code</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.postalCode" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="postal-code"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ getEmployerById.address.postal_code }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Postal code</b>
                            </span>

                            <input
                              type="text"
                              class="form-control"
                              id="postal-code"
                              placeholder="Postal Code"
                              v-model="selectedPostalCode"
                              autocomplete
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.postalCodeFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6 d-none d-sm-block">
                          <div
                            v-if="!editIconState.titleFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.title = true"
                            @mouseleave="editFields.title = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Title</b>
                            </span>

                            <div style="position: relative; height: 18px">
                              <div class="edit-btn">
                                <router-link v-if="editFields.title" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="title"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ getEmployerById.title }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Title</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="title"
                              v-model="selectedTitle"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              style="margin-right: 12px"
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.titleFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.cityFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.city = true"
                            @mouseleave="editFields.city = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Location</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.city" to>
                                  <i
                                    @click="showEditForm($event)"
                                    id="city"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <div
                                v-if="
                                  getEmployerById && getEmployerById.city && getEmployerById.country
                                "
                              >
                                {{ getEmployerById.city.name }},
                                {{ getEmployerById.country.name }}
                              </div>
                            </div>
                          </div>

                          <span class="d-flex new-location" v-else>
                            <span class="mr-0">
                              <b>Location</b>
                            </span>
                            <div class="location-container">
                              <v-select
                                class="country-select mr-1"
                                v-model="selectedCountry"
                                @input="
                                  fetchCitiesByCountryId($event);
                                  clearCity();
                                "
                                label="name"
                                placeholder="Country"
                                :options="getAllCountries"
                                :reduce="country => country"
                                :clearable="false"
                              >
                                <template v-slot:no-options="{ search, searching }">
                                  <template v-if="searching && search.length >= 3">
                                    No results found for <em>{{ search }}</em
                                    >.
                                  </template>
                                  <div style="opacity: 0.5" v-else>
                                    Please type at least 3 characters
                                  </div>
                                </template>
                              </v-select>

                              <v-select
                                class="city-select"
                                v-model="selectedCity"
                                @input="setCityModel($event)"
                                label="name"
                                :options="getCitiesListByCountry"
                                :reduce="city => city"
                                :clearable="true"
                              >
                                <template v-slot:no-options>
                                  <div style="opacity: 0.5">Please select a country first</div>
                                </template>
                              </v-select>
                            </div>

                            <button
                              v-show="!isInGlobalEditMode"
                              type="submit"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>
                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.cityFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>
                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.emailFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.email = true"
                            @mouseleave="editFields.email = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Email</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.email" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="email"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <div class="text-truncate" style="max-width: 260px;">
                                <a
                                  v-if="getEmployerById.email"
                                  :href="`mailto:${getEmployerById.email}`"
                                  class="mr-3"
                                  target="_top"
                                  >{{ getEmployerById.email }}</a
                                >
                              </div>
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Email</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="email"
                              v-model="selectedEmail"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.emailFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>
                        <li class="list-group-item col-md-6 d-none d-sm-block">
                          <div
                            v-if="!editIconState.invoiceEmailFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.invoiceEmail = true"
                            @mouseleave="editFields.invoiceEmail = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Invoicing email</b>
                            </span>

                            <div style="position: relative; height: 18px">
                              <div class="edit-btn">
                                <router-link v-if="editFields.invoiceEmail" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="invoice"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <div class="text-truncate" style="max-width: 260px;">
                                <a
                                  v-if="getEmployerById.invoice_email"
                                  :href="`mailto:${getEmployerById.invoice_email}`"
                                  class="mr-3"
                                  target="_top"
                                  >{{ getEmployerById.invoice_email }}</a
                                >
                              </div>
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Invoicing email</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="invoice"
                              v-model="selectedInvoice"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              style="margin-right: 12px"
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.invoiceEmailFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.websiteFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.website = true"
                            @mouseleave="editFields.website = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Website</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.website" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="website"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <a
                                v-if="getEmployerById.website"
                                :href="checkLinkedIin(getEmployerById.website)"
                                target="_blank"
                                >{{ getEmployerById.website | prettifyUrl }}</a
                              >
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Website</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="website"
                              placeholder="Website"
                              v-model="selectedWebsite"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.websiteFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>
                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.phoneFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.phone = true"
                            @mouseleave="editFields.phone = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Phone</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.phone" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="phone"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ getEmployerById.phone }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Phone</b>
                            </span>

                            <div class="new-phone">
                              <v-select
                                @input="addCountryCode(selectedCountryCode)"
                                style="font-size: 14px; height: 42px"
                                v-model="selectedCountryCode"
                                :options="
                                  [...getAllCountries].map(
                                    item => `${item.phone_code} ${item.name}`,
                                  )
                                "
                                :clearable="false"
                              >
                                <template v-slot:option="option">
                                  {{ option.label }}
                                </template>
                              </v-select>
                              <input
                                class="form-control"
                                id="phone"
                                v-model="selectedPhone"
                                type="tel"
                                pattern="\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}"
                              />

                              <button
                                v-show="!isInGlobalEditMode"
                                type="submit"
                                class="btn btn-outline btn-sm border mr-1"
                              >
                                <i class="fas fa-check"></i>
                              </button>

                              <CandidateEditFieldCancelBtn
                                v-show="!isInGlobalEditMode"
                                @clicked="editIconState.phoneFormShow = false"
                              >
                                <i class="fas fa-times"></i>
                              </CandidateEditFieldCancelBtn>
                            </div>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.emailSyncFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.emailSync = true"
                            @mouseleave="editFields.emailSync = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Sync email</b>
                            </span>

                            <div style="position: relative; height: 18px">
                              <div class="edit-btn">
                                <router-link v-if="editFields.emailSync" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="email-sync"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <a
                                v-if="getEmployerById.sync_imap_email"
                                :href="`mailto:${getEmployerById.sync_imap_email}`"
                                class="mr-3 text-truncate"
                                target="_top"
                                >{{ getEmployerById.sync_imap_email }}</a
                              >
                            </div>
                            <div
                              v-if="getEmployerById.sync_imap_email"
                              @click="checkImapConnection"
                              class="test"
                              title="Test connection"
                            >
                              <i
                                :style="isConnected ? 'color:green' : 'color:#999'"
                                class="fas fa-envelope"
                              ></i>
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Sync email</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="email-sync"
                              placeholder="email"
                              v-model="editFields.imap_email"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              style="margin-right: 12px"
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.emailSyncFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>
                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.careerPortalFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.careerPortal = true"
                            @mouseleave="editFields.careerPortal = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Career portal</b>
                            </span>

                            <div style="position: relative; height: 18px">
                              <div class="edit-btn">
                                <router-link v-if="editFields.careerPortal" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="career-portal"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <!--                         {{ getEmployerById.sync_imap_email }} -->
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Career portal</b>
                            </span>

                            <div class="custom-control custom-checkbox">
                              <input
                                id="notification"
                                class="mr-2 custom-control-input"
                                type="checkbox"
                                aria-label
                                @change="isCareerPortalEnabled = !isCareerPortalEnabled"
                              />
                              <label class="custom-control-label" for="notification"> </label>
                            </div>

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.careerPortalFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>
                        <li class="list-group-item col-md-6">
                          <div class="d-flex">
                            <span class="mr-3">Created by</span>
                            <span>{{ getEmployerById.created_by }}</span>
                          </div>
                        </li>
                        <li class="list-group-item col-md-6">
                          <div class="d-flex">
                            <span class="mr-3">Created date</span>
                            <span>{{
                              getEmployerById.created_at
                                | formatDate({
                                  format: getUserProfile.format_date,
                                  timezone: getUserProfile.timezone,
                                  hasHourAndMinutes: false,
                                })
                            }}</span>
                          </div>
                        </li>
                        <li class="list-group-item col-md-6">
                          <div class="d-flex">
                            <span class="mr-3">Last updated</span>
                            <span>{{
                              getEmployerById.updated_at
                                | formatDate({
                                  format: getUserProfile.format_date,
                                  timezone: getUserProfile.timezone,
                                  hasHourAndMinutes: false,
                                })
                            }}</span>
                          </div>
                        </li>
                        <li class="list-group-item col-md-6">
                          <div class="d-flex">
                            <span class="mr-3">Campaign</span>
                            <span>{{
                              getEmployerById.campaign_id ? getEmployerById.campaign_id : 'N/A'
                            }}</span>
                          </div>
                        </li>
                      </div>
                    </ul>
                  </form>
                </div>
                <div
                  class="tab-pane fade"
                  id="nav-comments"
                  role="tabpanel"
                  aria-labelledby="nav-comments-tab"
                >
                  <Comments
                    :key="key"
                    @add-candidate-comment="addCommentHandler"
                    @remove-comment="deleteCommentHandler"
                    @edit-comment="editCommentHandler"
                    :uuid="this.$route.params.candidate_id"
                    :commentsList="getEmployerComments"
                  />
                </div>

                <div
                  class="tab-pane fade"
                  id="nav-agreements"
                  role="tabpanel"
                  aria-labelledby="nav-agreements-tab"
                >
                  <div class="advertising">
                    <div class="row">
                      <div class="col-md-12">
                        <h3 class="custom-header-employer">Basic</h3>
                        <div class="row">
                          <div class="col-md-4">
                            <select
                              class="form-control select-style pr-4"
                              v-model="selectedAgreements.basic.basic"
                            >
                              <option v-for="option in basic" :key="option.id" :value="option.id">
                                {{ option.label }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="custom-header-employer">Sourcing</h5>
                        <div class="row">
                          <div class="col-md-4">
                            <select
                              class="form-control select-style pr-4"
                              v-model="selectedAgreements.sourcing.sourcing"
                            >
                              <option
                                v-for="option in sourcing"
                                :key="option.value"
                                :value="option.id"
                              >
                                {{ option.label }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <select
                              v-model="selectedAgreements.sourcing.price_plan_id"
                              class="form-control select-style pr-4"
                            >
                              <option
                                :value="plan.price_plan_id"
                                v-for="plan in sourcingPlans"
                                :key="plan.id"
                                >{{ plan.price_plan }} {{ plan.country_name }}
                                {{ `(${plan.currency_code})` }}</option
                              >
                            </select>
                          </div>
                          <div
                            v-if="getEmployerById.online_agreements_data"
                            class="col-md-4 d-flex align-items-center"
                            style="gap:5px"
                          >
                            <div
                              v-for="(item, index) in getEmployerById.online_agreements_data.filter(
                                i => i.type === 1,
                              )"
                              :key="index"
                            >
                              <popper
                                v-for="(document, index) in item.documents"
                                :key="index"
                                trigger="hover"
                                :options="{
                                  placement: 'top',
                                  modifiers: { offset: { offset: '0,10px' } },
                                }"
                              >
                                <div class="popper">
                                  {{ `Signed by ${item.full_name} on` }}
                                  {{
                                    item.signing_date
                                      | formatDate({
                                        format: getUserProfile.format_date,
                                        timezone: getUserProfile.timezone,
                                        hasHourAndMinutes: false,
                                      })
                                  }}
                                </div>
                                <a slot="reference">
                                  <div>
                                    <i
                                      style="color:red; font-size: 22px; cursor: pointer;"
                                      @click="previewDocument(document.document_id)"
                                      class="fas fa-file-pdf"
                                    ></i>
                                  </div>
                                </a>
                              </popper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="custom-header-employer">Full-service</h5>
                        <div class="row">
                          <div class="col-md-4">
                            <select
                              class="form-control select-style pr-4"
                              v-model="selectedAgreements.full_service.full_service"
                            >
                              <option
                                v-for="option in sourcing"
                                :key="option.value"
                                :value="option.id"
                              >
                                {{ option.label }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <select
                              v-model="selectedAgreements.full_service.price_plan_id"
                              class="form-control select-style pr-4"
                            >
                              <option
                                :value="plan.price_plan_id"
                                v-for="plan in fullServicePlans"
                                :key="plan.id"
                                >{{ plan.price_plan }} {{ plan.country_name }}
                                {{ `(${plan.currency_code})` }}</option
                              >
                            </select>
                          </div>
                          <div
                            v-if="getEmployerById.online_agreements_data"
                            class="col-md-4 d-flex align-items-center"
                            style="gap:5px"
                          >
                            <div
                              v-for="(item, index) in getEmployerById.online_agreements_data.filter(
                                i => i.type === 2,
                              )"
                              :key="index"
                            >
                              <popper
                                v-for="(document, index) in item.documents"
                                :key="index"
                                trigger="hover"
                                :options="{
                                  placement: 'top',
                                  modifiers: { offset: { offset: '0,10px' } },
                                }"
                              >
                                <div class="popper">
                                  {{ `Signed by ${item.full_name} on` }}
                                  {{
                                    item.signing_date
                                      | formatDate({
                                        format: getUserProfile.format_date,
                                        timezone: getUserProfile.timezone,
                                        hasHourAndMinutes: false,
                                      })
                                  }}
                                </div>
                                <a slot="reference">
                                  <div>
                                    <i
                                      style="color:red; font-size: 22px; cursor: pointer;"
                                      @click="previewDocument(document.document_id)"
                                      class="fas fa-file-pdf"
                                    ></i>
                                  </div>
                                </a>
                              </popper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="custom-header-employer">Nearshore</h5>
                        <div class="row">
                          <div class="col-md-4">
                            <select
                              class="form-control select-style pr-4"
                              v-model="selectedAgreements.nearshore.nearshore"
                            >
                              <option
                                v-for="option in sourcing"
                                :key="option.value"
                                :value="option.id"
                              >
                                {{ option.label }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <select
                              v-model="selectedAgreements.nearshore.price_plan_id"
                              class="form-control select-style pr-4"
                            >
                              <option
                                :value="plan.price_plan_id"
                                v-for="plan in nearshorePlans"
                                :key="plan.id"
                                >{{ plan.price_plan }} {{ plan.country_name }}
                                {{ `(${plan.currency_code})` }}</option
                              >
                            </select>
                          </div>

                          <div
                            v-if="getEmployerById.online_agreements_data"
                            class="col-md-4 d-flex align-items-center"
                            style="gap:5px"
                          >
                            <div
                              v-for="(item, index) in getEmployerById.online_agreements_data.filter(
                                i => i.type === 3,
                              )"
                              :key="index"
                            >
                              <popper
                                v-for="(document, index) in item.documents"
                                :key="index"
                                trigger="hover"
                                :options="{
                                  placement: 'top',
                                  modifiers: { offset: { offset: '0,10px' } },
                                }"
                              >
                                <div class="popper">
                                  {{ `Signed by ${item.full_name} on` }}
                                  {{
                                    item.signing_date
                                      | formatDate({
                                        format: getUserProfile.format_date,
                                        timezone: getUserProfile.timezone,
                                        hasHourAndMinutes: false,
                                      })
                                  }}
                                </div>
                                <a slot="reference">
                                  <div>
                                    <i
                                      style="color:red; font-size: 22px; cursor: pointer;"
                                      @click="previewDocument(document.document_id)"
                                      class="fas fa-file-pdf"
                                    ></i>
                                  </div>
                                </a>
                              </popper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="custom-header-employer">Freelancers</h5>
                        <div class="row">
                          <div class="col-md-4">
                            <select
                              class="form-control select-style pr-4"
                              v-model="selectedAgreements.freelancers.freelancers"
                            >
                              <option
                                v-for="option in sourcing"
                                :key="option.value"
                                :value="option.id"
                              >
                                {{ option.label }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <select
                              v-model="selectedAgreements.freelancers.price_plan_id"
                              class="form-control select-style pr-4"
                            >
                              <option
                                :value="plan.price_plan_id"
                                v-for="plan in freelancerPlans"
                                :key="plan.id"
                                >{{ plan.price_plan }} {{ plan.country_name }}
                                {{ `(${plan.currency_code})` }}</option
                              >
                            </select>
                          </div>
                          <div
                            v-if="getEmployerById.online_agreements_data"
                            class="col-md-4 d-flex align-items-center"
                            style="gap:5px"
                          >
                            <div
                              v-for="(item, index) in getEmployerById.online_agreements_data.filter(
                                i => i.type === 4,
                              )"
                              :key="index"
                            >
                              <popper
                                v-for="(document, index) in item.documents"
                                :key="index"
                                trigger="hover"
                                :options="{
                                  placement: 'top',
                                  modifiers: { offset: { offset: '0,10px' } },
                                }"
                              >
                                <div class="popper">
                                  {{ `Signed by ${item.full_name} on` }}
                                  {{
                                    item.signing_date
                                      | formatDate({
                                        format: getUserProfile.format_date,
                                        timezone: getUserProfile.timezone,
                                        hasHourAndMinutes: false,
                                      })
                                  }}
                                </div>
                                <a slot="reference">
                                  <div>
                                    <i
                                      style="color:red; font-size: 22px; cursor: pointer;"
                                      @click="previewDocument(document.document_id)"
                                      class="fas fa-file-pdf"
                                    ></i>
                                  </div>
                                </a>
                              </popper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-8 mt-5">
                        <div class="d-flex" style="justify-content: flex-end;">
                          <button
                            @click="saveNewEmployerStatus"
                            type="button"
                            class="btn btn-secondary ml-3"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="nav-jobs"
                  role="tabpanel"
                  aria-labelledby="nav-jobs-tab"
                >
                  <!--  <EmployerItemJobs /> -->
                </div>

                <div
                  class="tab-pane fade"
                  id="nav-activity"
                  role="tabpanel"
                  aria-labelledby="nav-activity-tab"
                >
                  <Activities
                    :activities="getEmployerById.activities"
                    @added-new-activity="getNewActivites"
                    @removed-activity="getNewActivites"
                  />
                </div>

                <div
                  class="tab-pane fade temp"
                  id="nav-templates"
                  role="tabpanel"
                  aria-labelledby="nav-templates-tab"
                  :key="componentKey"
                >
                  <div class="form-group">
                    <div class="d-flex">
                      <label class="label" for="comments-textarea">About Us</label>
                      <div class="buttons ml-auto mb-2">
                        <div v-if="!editAboutUs" class="edit-btn ml-auto">
                          <router-link to class="mr-1">
                            <i
                              @click="onEditAboutUs(aboutUsEditor)"
                              id="orgo"
                              class="fas fa-pen edit-icon"
                              style="color: #666"
                            ></i>
                          </router-link>
                        </div>
                        <div v-else>
                          <button
                            @click="updateEmployer"
                            type="button"
                            class="btn btn-outline btn-sm border mr-1"
                            style="color: green"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn @clicked="editAboutUs = false">
                            <i style="color: red" class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="!editAboutUs && aboutUsEditor.length > 0"
                      class="text-editor"
                      v-html="aboutUsEditor"
                    ></div>
                    <div v-if="!editAboutUs && aboutUsEditor.length === 0" class="text-editor">
                      <p>
                        Enter a general company description. This text will be inserted in the end
                        of the job ads by default.
                      </p>
                    </div>
                    <div v-show="editAboutUs">
                      <TextEditor v-model="aboutUsEditor" />
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="d-flex">
                      <label class="label" for="comments-textarea">Benefits</label>
                      <div class="buttons ml-auto mb-2">
                        <div v-if="!editBenefits" class="edit-btn ml-auto">
                          <router-link to class="mr-1">
                            <i
                              @click="onEditBenefits(benefitsEditor)"
                              id="orgo"
                              class="fas fa-pen edit-icon"
                              style="color: #666"
                            ></i>
                          </router-link>
                        </div>
                        <span v-else>
                          <button
                            @click="updateEmployer"
                            type="button"
                            class="btn btn-outline btn-sm border mr-1"
                            style="color: green"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <CandidateEditFieldCancelBtn @clicked="editBenefits = false">
                            <i style="color: red" class="fas fa-times"></i>
                          </CandidateEditFieldCancelBtn>
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="!editBenefits && benefitsEditor.length > 0"
                      class="text-editor"
                      v-html="benefitsEditor"
                    ></div>
                    <div v-if="!editBenefits && benefitsEditor.length === 0" class="text-editor">
                      <p>
                        Enter a text about what benefits that you offer. This text will be inserted
                        in the job ads when using the job ad text generator.
                      </p>
                    </div>

                    <div v-show="editBenefits">
                      <TextEditor v-model="benefitsEditor" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 desktop-only employer-aside">
            <Activities
              :isLoading="isLoading"
              :activities="currentActivities"
              @getActivities="loadMoreActivities"
              @added-new-activity="getNewActivites"
              @removed-activity="getNewActivites"
            />
          </div>
        </div>
        <div class="row desktop-only">
          <div class="col-12">
            <UsersAndLogs class="d-none d-sm-block" />
            <EmployerItemJobs />
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>
    </div>
    <portal-target name="add-employer-modal"></portal-target>
    <!-- End page-content-wrapper -->

    <!-- Change Avatar Modal -->
    <div
      class="modal fade edit-modal"
      id="changeAvatarModal"
      tabindex="-1"
      aria-labelledby="changeAvatarModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Change your profile picture</h5>
            <button
              ref="closeModalUploadAvatarBtn"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div>
              <div class="d-flex justify-content-center my-4">
                <img
                  v-if="!previewAvatar"
                  class="employer-picture-preview rounded-circle"
                  src="https://media-exp1.licdn.com/dms/image/C560BAQF_1BqcCYk5iw/company-logo_200_200/0?e=2159024400&v=beta&t=VIwymtUGPLl3EApxziNxNiYNmAJHRYrTq28-lPwErsM"
                  style="width: 64px; height: 64px"
                  alt="avatar"
                />
                <div
                  v-else
                  class="employer-picture-preview rounded-circle mr-3"
                  :style="{ 'background-image': `url(${previewAvatar})` }"
                  style="background-size: cover"
                ></div>
              </div>
              <div class="d-flex justify-content-center my-4">
                <span class="mr-2">
                  <label for="upload-avatar" class="btn btn-primary btn-sm file-upload-label mb-0"
                    ><i class="fas fa-upload"></i>Upload picture</label
                  >
                  <input
                    type="file"
                    id="upload-avatar"
                    ref="candidateAvatar"
                    name="candidateAvatar"
                    @input="onCandidateChangeAvatar($event)"
                    accept=".jpg,.png,.jpeg,.gif,.svg"
                  />
                </span>
                <span>
                  <button
                    class="btn btn-danger btn-sm mb-0"
                    @click="onCandidateRemoveAvatar"
                    :disabled="!previewAvatar ? true : false"
                  >
                    <i class="fas fa-upload"></i>Remove picture
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="uploadEmployerAvatar()" type="button" class="btn btn-primary">
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Change Avatar Modal -->

    <!-- Delete Job Modal -->
    <div
      class="modal fade edit-modal"
      id="deleteEmployerModal"
      tabindex="-1"
      aria-labelledby="deleteEmployerModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteEmployerModal">Delete Employer</h5>
            <button
              ref="closeModalBtn"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>
              Please confirm that you want to delete <strong>{{ getEmployerById.name }}</strong
              >. This action will permanently delete the information.
            </p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="removeEmployer" type="button" class="btn btn-primary">Delete</button>

            <button
              ref="closeModalBtn"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Delete Job Modal -->

    <!-- Change Employer Status Modal -->
    <CustomMainModal
      @close="employerStatusModalShow = false"
      v-show="employerStatusModalShow"
      :header="false"
      modalSize="modal-sm"
    >
      <p>Please confirm that you want to change agreement level.</p>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary" @click="saveNewEmployerStatus">
          Confirm
        </button>
        <button type="button" class="btn btn-secondary" @click="onCancelSetEmployerAgreement">
          Cancel
        </button>
      </div>
      <Spinner :isLoading="isLoading" />
    </CustomMainModal>
    <!-- End Change Employer Status Modal -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';

import CandidateEditFieldCancelBtn from '../common/CandidateEditFieldCancelBtn';
import Sidebar from '../../Navigations/Sidebar';
import TopNavbar from '../../Navigations/TopNavbar';

import CustomMainModal from '../../Modals/CustomMainModal';
import AddEmployerBtnModal from './AddEmployerBtnModal';

// Activities AND EMAILS
import Activities from '../common/Activities';

import EmployerItemJobs from '../Employers/EmployerItemJobs';
import UsersAndLogs from '../Employers/UsersAndLogs';
import Comments from '../common/Comments';

import Avatar from './EmployerAvatar.vue';
import TextEditor from '@/components/common/TextEditor';
import { errorService } from '../../../services/errorService';
import { MESSAGES } from '../../../constants';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  components: {
    Avatar,
    Sidebar,
    Comments,
    TopNavbar,
    Activities,
    UsersAndLogs,
    TextEditor,
    CustomMainModal,
    EmployerItemJobs,
    AddEmployerBtnModal,
    CandidateEditFieldCancelBtn,
  },
  mixins: [toggleSidebarNav, titleMixin],
  title() {
    return 'Employer | Jobshark';
  },
  data: () => ({
    currentPricePlans: [],
    sourcingPlans: [],
    fullServicePlans: [],
    nearshorePlans: [],
    freelancerPlans: [],
    isConnected: false,
    currentActivities: [],
    pageCount: 10,
    currentPage: '',
    tab: 0,
    editAboutUs: false,
    editBenefits: false,
    selectedAvatar: '',
    componentKey: 0,
    aboutUsEditor: '',
    benefitsEditor: '',
    selectedName: '',
    selectedOrgo: '',
    selectedVat: '',
    selectedCity: {},
    selectedCountry: {},
    selectedWebsite: '',
    selectedFirstName: '',
    selectedLastName: '',
    selectedTitle: '',
    selectedEmail: '',
    selectedInvoice: '',
    selectedPostalCode: '',
    selectedStreet: '',
    selectedCountryCode: '',
    selectedPhone: '',
    selectedDescription: '',
    selectedAddress: '',
    selectedSecondaryEmail: '',
    selectedVat: '',
    isCareerPortalEnabled: false,
    selectedAgreements: {
      basic: '',
      sourcing: '',
      full_service: '',
      nearshore: '',
      freelancers: '',
    },
    /*    aboutus: '',
    benefits: '', */
    currentAddress: '',
    employerAvatar: '',
    previewAvatar: '',
    employerStatusOptions: [
      { value: 0, label: 'Advertising' },
      { value: 1, label: 'Recruiting' },
      { value: 2, label: 'Internal' },
    ],
    selectedEmployerStatus: 0,
    actualEmployerStatus: 0,
    key: 0,
    careerPortal: false,
    relocation: false,
    showModal: false,
    employerStatusModalShow: false,
    isInGlobalEditMode: false,
    isToggled: false,
    isLoading: false,
    isNotificationEnabled: false,
    employerData: {},
    editFields: {
      invoiceEmail: false,
      vat: false,
      employerName: false,
      orgo: false,
      firstName: false,
      streetAddress: false,
      lastName: false,
      postalCode: false,
      title: false,
      city: false,
      country: false,
      email: false,
      website: false,
      phone: false,
      emailSync: false,
      imap_email: '',
      notifications: false,
      careerPortal: false,
    },
    editIconState: {
      invoiceEmailFormShow: false,
      vatFormShow: false,
      employerNameFormShow: false,
      orgoFormShow: false,
      firstNameFormShow: false,
      streetAddressFormShow: false,
      lastNameFormShow: false,
      postalCodeFormShow: false,
      titleFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      emailFormShow: false,
      websiteFormShow: false,
      phoneFormShow: false,
      emailSyncFormShow: false,
      notificationsFormShow: false,
      careerPortalFormShow: false,
      isReadonly: false,
    },
    /* Agremeent statuses */
    basic: [
      { id: 1, label: 'Hide' },
      { id: 2, label: 'Promote' },
    ],
    sourcing: [
      { id: 1, label: 'Hide' },
      { id: 2, label: 'Promote' },
      { id: 3, label: 'Agreement' },
    ],
  }),
  methods: {
    ...mapActions([
      'retrieveUserProfile',
      'updateEmployerById',
      'addEmployerComment',
      'editEmployerComment',
      'retrieveEmployerById',
      'setEmployerAgreement',
      'removeEmployerComment',
      'retrieveEmployerComments',
      'retrieveCitiesListByCountryId',
      'retrieveActivitiesForEmployer',
      'retrieveEmployerDocumentPreview',
    ]),
    /*     chnageAgreement(name, id) {
      this.selectedAgreements[name] = {
        [name]: id,
      };
    }, */

    checkLinkedIin(url) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return 'https://' + url;
      } else {
        return url;
      }
    },

    previewDocument(id) {
      this.retrieveEmployerDocumentPreview({ uuid: id }).then(response => {
        const blob = new window.Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    },

    seenProfile() {
      axios.post(
        `${process.env.VUE_APP_API_URL}/admin/recentseen/store`,
        {
          employer_id: this.$route.params.employer_id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        },
      );
    },
    onCloseAddEmployerModal() {
      this.showModal = false;
    },
    loadMoreActivities() {
      if (this.currentPage < this.last_page) {
        this.currentPage++;
        this.retrieveActivitiesForEmployer({
          employer_id: this.$route.params.employer_id,
          count: this.pageCount,
          page: this.currentPage,
        }).then(() => {
          this.currentActivities = [
            ...this.currentActivities,
            ...Object.values(this.getActivitiesForEmployer.data),
          ];
        });
      }
    },
    onEditAboutUs(aboutus) {
      if (aboutus !== null) {
        this.aboutUsEditor = aboutus;
      }
      this.editAboutUs = true;
    },
    onEditBenefits(benefits) {
      if (benefits !== null) {
        this.benefitsEditor = this.removeHtmlTags(benefits, 'div');
      }
      this.editBenefits = true;
    },
    forceRerender() {
      this.componentKey++;
      this.isReadonly = false;
    },
    removeHtmlTags(str, ...args) {
      const removeAllDivTags = /<[/]{0,1}(div)[^><]*>/g;
      // const regex = /(<([^>]+)>)/gi;

      return str
        .replace(removeAllDivTags, '')
        .replace(/<!--.*?-->/g, '')
        .replace(/\r?\n/g, '');
    },
    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.selectedPhone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    addCountryName(phone) {
      if (phone !== null) {
        let extractedNumbers = phone.match(/^(\+\d+)\s/);
        if (extractedNumbers) {
          let countryCode = extractedNumbers[1]; // Extracted numbers before the space
          let exists = this.getAllCountries.find(country => country.phone_code === countryCode);

          if (exists) {
            return exists.name;
          } else {
            return '';
          }
        }
      }
    },
    clearCity() {
      this.selectedCity = '';
    },
    fetchCitiesByCountryId(country) {
      this.retrieveCitiesListByCountryId({ id: country.id });
    },
    addCommentHandler(comment) {
      if (comment) {
        const normalizedComment = comment.trim();

        this.addEmployerComment({
          js_employer_id: this.$route.params.employer_id,
          message: normalizedComment,
        })
          .then(() => {
            this.retrieveEmployerComments({ js_employer_id: this.$route.params.employer_id });

            this.$toasted.show(MESSAGES.commentAddedSuccess, {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(() => {
            this.$toasted.error(MESSAGES.commentAddedError, {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      } else {
        this.$toasted.info(MESSAGES.emptyComment, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 10000,
        });
      }
    },
    editCommentHandler(commentData) {
      this.editEmployerComment({ comment_id: commentData.id, data: commentData.comment })
        .then(() => {
          this.retrieveEmployerComments({ js_employer_id: this.$route.params.employer_id });

          this.$toasted.success(MESSAGES.commentAddedSuccess, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error(MESSAGES.commentAddedError, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    deleteCommentHandler(commentID) {
      this.removeEmployerComment({ comment_id: commentID })
        .then(() => {
          this.retrieveEmployerComments({ js_employer_id: this.$route.params.employer_id });

          this.$toasted.show(MESSAGES.commentDeletedSuccess, {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error(MESSAGES.commentDeletedError, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    getNewActivites() {
      this.retrieveActivitiesForEmployer({
        employer_id: this.$route.params.employer_id,
        page: 1,
        count: 10,
      })
        .then(() => {
          this.isLoading = false;
          this.currentActivities = this.getActivitiesForEmployer.data;
          this.last_page = this.getActivitiesForEmployer.last_page;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getAddress() {
      this.currentAddress = this.getEmployerById.address.address;
    },
    onCandidateChangeAvatar() {},
    uploadEmployerAvatar() {},
    onCandidateRemoveAvatar() {},
    checkImapConnection() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/employer/checkimap`,
          {
            imap_email: this.getEmployerById.sync_imap_email,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.isConnected = true;
          this.$toasted.success('Sync email is successfully verified', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          this.isConnected = false;
          this.$toasted.error('Sync email is not connected', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    removeEmployer() {
      axios
        .delete(
          `${process.env.VUE_APP_API_URL}/admin/employer/delete/${this.$route.params.employer_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$refs.closeModalBtn.click();
          this.$router.push({ name: 'admin-employers' });
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    updateEmployer() {
      if (!this.selectedCity || !this.selectedCountry) {
        this.$toasted.error(`Please enter City and Country before editing other information`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      }
      if (this.benefitsEditor === '<p><br></p>') {
        this.benefitsEditor = '';
      }

      if (this.aboutUsEditor === '<p><br></p>') {
        this.aboutUsEditor = '';
      }

      this.updateEmployerById({
        js_employer_id: this.$route.params.employer_id,
        name: this.selectedName,
        registration_number: this.selectedOrgo,
        eu_vat_number: this.selectedVat,
        city_id: this.selectedCity.id,
        country_id: this.selectedCountry.id,
        website: this.selectedWebsite,
        first_name: this.selectedFirstName,
        last_name: this.selectedLastName,
        title: this.selectedTitle,
        email: this.selectedEmail,
        postal_code: this.selectedPostalCode,
        street: this.selectedAddress,
        phone_number: this.selectedPhone,
        description: this.aboutUsEditor,
        benefits: this.benefitsEditor,
        email_notifications: this.isNotificationEnabled,
        sync_imap_email: this.editFields.imap_email,
        invoice_email: this.selectedInvoice,
      })
        .then(() => {
          this.editAboutUs = false;
          this.editBenefits = false;
          for (const key in this.editIconState) {
            this.editIconState[key] = false;
          }
          this.retrieveEmployerById(this.$route.params.employer_id);

          this.$toasted.success(MESSAGES.updateEmployerSuccess, {
            theme: 'bubble',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });

      this.isInGlobalEditMode = false;
    },
    onCancelUpdateForm() {
      this.isInGlobalEditMode = false;
      this.$refs.globalUpdateForm.reset();
    },
    changeGlobalEditMode() {
      this.isInGlobalEditMode = !this.isInGlobalEditMode;
      this.selectedCountryCode = this.addCountryName(this.getEmployerById.phone);
      this.selectedOrgo = this.getEmployerById.registration_number;
      this.selectedVat = this.getEmployerById.eu_vat_number;
      this.selectedName = this.getEmployerById.name;
      this.selectedFirstName = this.getEmployerById.first_name;
      this.selectedLastName = this.getEmployerById.last_name;
      this.selectedEmail = this.getEmployerById.email;
      this.selectedTitle = this.getEmployerById.title;
      this.selectedSecondaryEmail = this.getEmployerById.email2;
      this.selectedPhone = this.getEmployerById.phone;
      this.selectedAddress = this.getEmployerById.address.address;
      this.selectedPostalCode = this.getEmployerById.address.postal_code;
      this.selectedLinkedin = this.getEmployerById.linkedin;
      this.selectedWebPage = this.getEmployerById.webpage;
      this.selectedCity = this.getEmployerById.city;
      this.selectedCountry = this.getEmployerById.country;
      this.editFields.imap_email = this.getEmployerById.sync_imap_email;
      this.selectedInvoice = this.getEmployerById.invoice_email;
    },
    onChangeEmployerStatus() {
      this.employerStatusModalShow = true;
    },
    saveNewEmployerStatus() {
      this.isLoading = true;

      this.setEmployerAgreement({
        js_employer_id: this.$route.params.employer_id,
        agreements: this.selectedAgreements,
      }).then(() => {
        this.isLoading = false;
        this.employerStatusModalShow = false;
        this.actualEmployerStatus = this.selectedEmployerStatus;
        this.$toasted.success('Saved', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });
    },
    onCancelSetEmployerAgreement() {
      this.employerStatusModalShow = false;
      this.selectedEmployerStatus = this.actualEmployerStatus;
    },
    showEditForm(e) {
      if (e.target.id === 'invoice') {
        this.editIconState.invoiceEmailFormShow = !this.editIconState.invoiceEmailFormShow;
      }
      if (e.target.id === 'vat') {
        this.editIconState.vatFormShow = !this.editIconState.vatFormShow;
      }

      if (e.target.id === 'orgo') {
        this.editIconState.orgoFormShow = !this.editIconState.orgoFormShow;
      }

      if (e.target.id === 'first-name') {
        this.editIconState.firstNameFormShow = !this.editIconState.firstNameFormShow;
      }

      if (e.target.id === 'last-name') {
        this.editIconState.lastNameFormShow = !this.editIconState.lastNameFormShow;
      }

      if (e.target.id === 'street-address') {
        this.editIconState.streetAddressFormShow = !this.editIconState.streetAddressFormShow;
      }

      if (e.target.id === 'postal-code') {
        this.editIconState.postalCodeFormShow = !this.editIconState.postalCodeFormShow;
      }

      if (e.target.id === 'title') {
        this.editIconState.titleFormShow = !this.editIconState.titleFormShow;
      }

      if (e.target.id === 'city') {
        this.editIconState.cityFormShow = !this.editIconState.cityFormShow;
      }

      if (e.target.id === 'country') {
        this.editIconState.countryFormShow = !this.editIconState.countryFormShow;
      }

      if (e.target.id === 'email') {
        this.editIconState.emailFormShow = !this.editIconState.emailFormShow;
      }

      if (e.target.id === 'website') {
        this.editIconState.websiteFormShow = !this.editIconState.websiteFormShow;
      }

      if (e.target.id === 'phone') {
        this.selectedPhone = this.getEmployerById.phone;
        this.selectedCountryCode = this.addCountryName(this.getEmployerById.phone);
        this.editIconState.phoneFormShow = !this.editIconState.phoneFormShow;
      }

      if (e.target.id === 'email-sync') {
        this.editIconState.emailSyncFormShow = !this.editIconState.emailSyncFormShow;
      }

      if (e.target.id === 'notifications') {
        this.editIconState.notificationsFormShow = !this.editIconState.notificationsFormShow;
      }

      if (e.target.id === 'career-portal') {
        this.editIconState.careerPortalFormShow = !this.editIconState.careerPortalFormShow;
      }
    },
    getAvatar() {
      this.retrieveEmployerById(this.$route.params.employer_id).then(() => {
        this.selectedAvatar = this.getEmployerById.photo;
      });
    },
    setAgreementOnLoad() {
      this.selectedAgreements.basic = {
        basic: this.getEmployerById.basic,
        price_plan_id: '',
      };

      this.selectedAgreements.sourcing = {
        sourcing: this.getEmployerById.sourcing,
        price_plan_id: '',
      };
      this.selectedAgreements.full_service = {
        full_service: this.getEmployerById.full_service,
        price_plan_id: '',
      };
      this.selectedAgreements.nearshore = {
        nearshore: this.getEmployerById.nearshore,
        price_plan_id: '',
      };
      this.selectedAgreements.freelancers = {
        freelancers: this.getEmployerById.freelancers,
        price_plan_id: '',
      };

      const typeMap = {
        0: 'basic',
        1: 'sourcing',
        2: 'full_service',
        3: 'nearshore',
        4: 'freelancers',
      };

      for (const agreement of this.getEmployerById.online_agreements_data) {
        const { type, price_plan } = agreement;
        if (typeMap[type]) {
          const key = typeMap[type];
          if (price_plan !== null) {
            this.selectedAgreements[key].price_plan_id = price_plan.price_plan_id;
          }
        }
      }
    },

    getPricePlans() {
      axios(`${process.env.VUE_APP_API_URL}/admin/priceplan/get`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        res.data.forEach(plan => {
          switch (plan.type) {
            case 1:
              this.sourcingPlans.push(plan);
              break;
            case 2:
              this.fullServicePlans.push(plan);
              break;
            case 3:
              this.nearshorePlans.push(plan);
              break;
            case 4:
              this.freelancerPlans.push(plan);
              break;
            default:
              break;
          }
        });
      });
    },
  },
  computed: {
    ...mapGetters([
      'getAccType',
      'getEmployerById',
      'getUserProfile',
      'getEmployerComments',
      'getCitiesListByCountry',
      'getAllCountries',
      'getActivitiesForEmployer',
    ]),

    filteredAgreements(type) {
      return this.getEmployerById.online_agreements_data.filter(item => item.type === type);
    },
  },
  mounted() {
    this.getPricePlans();
    this.isLoading = true;
    this.seenProfile();
    this.retrieveActivitiesForEmployer({
      employer_id: this.$route.params.employer_id,
      page: 1,
      count: 1000,
    })
      .then(() => {
        this.isLoading = false;
        this.currentActivities = this.getActivitiesForEmployer.data;
        this.last_page = this.getActivitiesForEmployer.last_page;
      })
      .catch(() => {
        this.isLoading = false;
      });

    this.retrieveUserProfile()
      .then(() => {
        this.retrieveEmployerById(this.$route.params.employer_id)
          .then(response => {
            this.updateMeta();
            this.isLoading = false;
            this.actualEmployerStatus = response.data.agreement;
            this.selectedEmployerStatus = this.actualEmployerStatus;
            this.selectedName = this.getEmployerById.name;
            this.selectedOrgo = this.getEmployerById.registration_number;
            this.selectedVat = this.getEmployerById.eu_vat_number;
            this.selectedCountry = this.getEmployerById.country;
            this.selectedCity = this.getEmployerById.city;
            this.selectedWebsite = this.getEmployerById.website;
            this.selectedFirstName = this.getEmployerById.first_name;
            this.selectedLastName = this.getEmployerById.last_name;
            this.selectedEmail = this.getEmployerById.email;
            this.selectedPostalCode = this.getEmployerById.address.postal_code;
            this.selectedAddress = this.getEmployerById.address.address;
            this.selectedPhone = this.getEmployerById.phone;
            this.selectedTitle = this.getEmployerById.title;
            this.selectedAvatar = this.getEmployerById.photo;
            this.editFields.imap_email = this.getEmployerById.sync_imap_email;
            this.selectedInvoice = this.getEmployerById.invoice_email;
            this.fetchCitiesByCountryId(response.data.country);
            this.aboutUsEditor = this.removeHtmlTags(
              this.getEmployerById.description,
              'b',
              'u',
              'p',
            );
            this.benefitsEditor = this.removeHtmlTags(this.getEmployerById.benefits, 'b', 'u', 'p');

            this.aboutUsEditor = this.getEmployerById.description;
            this.benefitsEditor = this.getEmployerById.benefits;

            this.forceRerender();
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          });

        this.retrieveEmployerComments({ js_employer_id: this.$route.params.employer_id });
        this.getAvatar();
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

b {
  font-weight: 700 !important;
}

.custom-header-employer {
  font-size: 16px;
  font-weight: 700;
  border-bottom: 1px solid #ddd;
  margin: 25px 0 12px 0;
  padding-bottom: 12px;
}

.advertising {
  font-family: $font-family-sans-lato;
  padding: 20px 0 0 0;
  margin-left: 12px;
  .form-group {
    margin-bottom: 20px;
    label {
      font-size: 14px;
      font-weight: 700;
    }
  }
}

.test {
  position: absolute;
  padding: 2px 8px;
  top: 28px;
  right: 5px;
  border-radius: 2px;
  cursor: pointer;
  color: #fff;
}

.badge {
  background: mix($color-white, $btn-default-color, 50);
  color: #fff;
  margin-left: 5px;
  text-align: center;
  animation: pulse 2s infinite;
  animation-duration: pulse 10s;
  -webkit-animation-duration: 5s;
}

@keyframes pulse {
  0% {
  }
  50% {
    -moz-box-shadow: 0 0 0 0 $color-orange;
    box-shadow: 0 0 0 0 $color-orange;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.label {
  font-weight: 700;
}

.text-editor {
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 12px;
  margin: 6px 0;
}
#description {
  padding: 0 24px;
}
.card {
  height: 895px;
  margin: 0 0 24px 0;
  padding-bottom: 0px;
  .tab-content {
    margin: 1rem;
  }
}

.tech-icons {
  img {
    width: 30px;
    height: auto;
  }

  .icon-container:not(:last-child) {
    margin-right: 20px;
  }
}

.opted-checkbox {
  margin-right: 1rem;
}

.list-group {
  .list-group-item {
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    background-color: transparent;
    padding-right: 4px !important;
    .btn {
      background-color: #fff;
      border: 1px solid rgba(60, 60, 60, 0.26) !important;
      width: 24px;
      height: 24px;
      margin-left: 2px;
      font-size: 12px;
      flex-shrink: 0;
      border-radius: 5px;
      padding: 0;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-top: 2.4px;
      .fa-check {
        color: green;
      }
      .fa-times {
        color: Red;
      }
    }
  }
}

.employer-picture {
  position: relative;
  width: 64px;
  height: 64px;
  margin-right: 12px !important;
  flex-shrink: 0;
  .btn-success {
    margin-right: 10px;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}

.candidate-edit {
  float: right;
  margin-top: 10px;

  &-icon {
    fill: #a3a6b4;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.candidate-info-form {
  /* margin-left: -2rem; */

  button {
    padding-top: 1px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 1px;

    i {
      font-size: 8px;
    }
  }
}

.edit-icon {
  font-size: 1.1rem !important;
}

form {
  input {
    height: 30px;
  }
}

.employer-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  margin: 0 7px 0 7px;
  overflow: hidden;

  .list-group-item {
    border: none !important;
    .d-flex {
      border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
      margin: 3px 0px;
      padding: 12px 0;
      height: 46px;
      align-items: center;
    }
  }

  li span {
    min-width: 140px !important;
    display: inline-block;
    white-space: nowrap;
    text-align: justify;
    margin-right: 1rem;
  }

  li span:first-child {
    font-weight: 700;
  }

  .edit-btn {
    position: absolute;
    top: 0;
    left: -25px;
    .edit-icon {
      color: #666;
    }
  }
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}

.form-buttons {
  align-self: center;
  display: flex;
  width: 150px;
  flex-wrap: wrap;
  height: 38px;
  i {
    margin-left: auto;
  }
}

@media only screen and (max-width: 1251px) {
  #description {
    padding: 0;
  }
  .card {
    margin-top: 24px !important;
  }
  .employer-aside {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  #description {
    padding: 0;
    .card {
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
      margin: 24px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      .tab-content {
        margin: 0;
      }
    }
    .container {
      max-width: 100%;
    }
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .no-mobile {
    border: none;
  }
  .list-group-item {
    .d-flex {
      margin: 3px 12px !important;
    }
  }
  .temp {
    margin: 1rem;
  }
}

@media only screen and (max-width: 768px) {
  #description {
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .no-mobile {
    border: none;
  }
  .temp {
    margin: 1rem;
  }
}

@media only screen and (max-width: 576px) {
  #description {
    padding: 0;
    overflow: hidden;
    .card {
      margin: 0 !important;
    }
  }

  .card .tab-content {
    margin: 1rem;
  }

  .no-mobile {
    border: none !important;
    margin-top: 0 !important;
  }
  .candidate {
    padding: 10px 5px;
    figure {
      width: 43px;
      height: 43px;
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        max-width: 100% !important;
        max-height: 100% !important;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}
</style>
